import { select, put } from 'redux-saga/effects';
import _ from 'lodash';
import * as actions from '../state';

export default function* rememberBoard() {
  const savedBoardState = yield select((state) => state.editHistory.savedBoardState);

  if (!savedBoardState) { // true if a previous board state is already in memory
    const board = yield select(actions.readStateBoard);
    const charts = yield select(actions.readStateCharts);

    yield put(actions.originalBoard(_.cloneDeep(board)));
    yield put(actions.originalCharts(_.cloneDeep(charts)));
    yield put(actions.savedBoardState(true));
  }
}
